module.exports = __webpack_public_path__ + "static/media/ornaments.d238f77c.jpg";